import React from "react";
import { useNavigate } from "react-router-dom";

function SignupNudgeModal({ show, onClose }) {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="nudge-overlay">
      <div className="nudge-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="nudge-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="nudge-title">DON'T LOSE YOUR PROGRESS!</h2>

        <ul className="nudge-perks">
          <li>
            <div>
              <strong>View your stats</strong>
              <span>Track your win rate and guess distribution</span>
            </div>
          </li>
          <li>
            <div>
              <strong>Your streaks</strong>
              <span>See how many days in a row you can guess correctly</span>
            </div>
          </li>
          <li>
            <div>
              <strong>Save your progress</strong>
              <span>Pick up right where you left off</span>
            </div>
          </li>
        </ul>

        <div className="nudge-actions">
          <button
            className="nudge-btn-primary"
            onClick={() => {
              onClose();
              navigate("/signup");
            }}
          >
            SIGN UP FOR FREE
          </button>
          <p className="nudge-disclaimer">Takes less than 10 seconds.</p>
          <button
            className="nudge-btn-ghost"
            onClick={onClose}
          >
            Continue as Guest
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignupNudgeModal;
